import { SectionHandler } from '../entity.handler';
import { AdminEditorService } from '../../admin.service';
import { ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

export interface InlineListItem {
    id: string;
    icon: string;
    name: string;
    description: string | SafeHtml;
}


export interface ListSectionValues {
    items: InlineListItem[];
}

export abstract class InlineListSectionHandler<T> implements SectionHandler<T, ListSectionValues> {

    type = 'inline-list';
    icon = '';
    bulk: false;

    title = this.translate('TITLE');
    description = this.translate(`DESC`);
    emptyText = '';

    actionAdd = true;
    actionDelete = true;
    actionReload = false;

    autoReloadSeconds = 0; // don't auto reload by default

    // implement this method if you'd like to inject a custom component for the list items
    getComponentFactory: (resolver: ComponentFactoryResolver) => ComponentFactory<any> = null;

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.SHARED.LIST.${key}`, values);
    }

    applyUpdate(_entity: T, _payload: any): Promise<any> {
        return Promise.reject(new Error('applyUpdate not supported'));
    }

    mapEntityToEditor(_entity: T): Promise<ListSectionValues> {
        return Promise.reject(new Error('mapEntityToEditor not supported'));
    }

    mapEditorToEntity(_entity: any, _values: ListSectionValues): Promise<any> {
        return Promise.reject(new Error('mapEditorToEntity not supported'));
    }

    abstract getItems(entity: T, offset: number, limit: number): Promise<InlineListItem[]>;
    
    abstract actionClicked(action: string, entity: T, item: InlineListItem): Promise<T>;


}
